<div layout="row" layout-align="center center">
    <div class="d-flex flex-row-reverse">
        <img src="assets/img/sitioseguro.jpg" class="rounded float-right ml-5 mb-5">
        <p>Todos los derechos reservados <strong *ngIf="TemaActivoGlobal()">Global Assist Group</strong> Copyright 2021<br>versión {{configuracionVersionService.versionVisualizar}}</p>
    </div>
</div>